import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteShopper, closeDeleteShopperModal } from 'redux/actions/shoppers'

const DeleteModal = ({ isOpen, closeModal, shopper, deleteShopper, isLoading, source, history }) => !shopper ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Proyecto</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar al comprador {shopper.name} ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteShopper({shopper, source, history})}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  shopper: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  source: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  deleteShopper: PropTypes.func.isRequired,
}

const mapStateToProps = ({ shoppers: { source, openedDeleteShopperModal, selectedShopper, deletingShopper }}) => {
  return ({
    source,
    isOpen: openedDeleteShopperModal,
    shopper: selectedShopper,
    isLoading: deletingShopper
  })
}

const mapDispatchToProps = dispatch => ({
  deleteShopper: info => dispatch(deleteShopper(info)),
  closeModal: () => dispatch(closeDeleteShopperModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
